import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { CsSelectScrollComponent } from './cs-select-scroll/cs-select-scroll.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CsInputNumberComponent } from './cs-input-number/cs-input-number.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { CsDatePickerComponent } from './cs-date-picker/cs-date-picker.component';
import { CsPaginationComponent } from './cs-pagination/cs-pagination.component';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { CsInputSearchComponent } from './cs-input-search/cs-input-search.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { RenderErrorsComponent } from './render-errors/render-errors.component';
import { CsCheckboxComponent } from './cs-checkbox/cs-checkbox.component';
import { CsRadioGroupComponent } from './cs-radio-group/cs-radio-group.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import {NzEmptyModule} from "ng-zorro-antd/empty";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import { RangeNumberComponent } from './range-number/range-number.component';
import {NzSliderModule} from "ng-zorro-antd/slider";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzPopoverModule} from "ng-zorro-antd/popover";
import { CsSelectComponent } from './cs-select/cs-select.component';
import {PipeModule} from '../pipe/pipe.module';
import {VssUiDirectivesModule} from '../directives/vss-ui-directives.module';
import {vssProviders} from '../../vss.providers';
import { VssFormItemComponent } from './form-item/form-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { CsInputTextComponent } from './cs-input-text/cs-input-text.component';
import { CsPagination2Component } from './cs-pagination-2/cs-pagination-2.component';


@NgModule({
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    NzInputNumberModule,
    NzDatePickerModule,
    VssUiDirectivesModule,
    NzPaginationModule,
    NzIconModule,
    NzFormModule,
    NzInputModule,
    ReactiveFormsModule,
    NzCheckboxModule,
    NzCheckboxModule,
    NzRadioModule,
    NzEmptyModule,
    NzToolTipModule,
    NzSliderModule,
    PipeModule,
    NzButtonModule,
    NzPopoverModule,
    TranslateModule
  ],
  declarations: [
    CsSelectScrollComponent,
    CsInputNumberComponent,
    CsDatePickerComponent,
    CsPaginationComponent,
    CsInputSearchComponent,
    RenderErrorsComponent,
    CsCheckboxComponent,
    CsRadioGroupComponent,
    CsSelectComponent,
    RangeNumberComponent,
    VssFormItemComponent,
    CsInputTextComponent,
    CsPagination2Component
  ],
  exports: [
    CsSelectScrollComponent,
    CsInputNumberComponent,
    CsDatePickerComponent,
    CsPaginationComponent,
    CsInputSearchComponent,
    RenderErrorsComponent,
    CsCheckboxComponent,
    CsRadioGroupComponent,
    ReactiveFormsModule,
    CsSelectComponent,
    RangeNumberComponent,
    VssFormItemComponent,
    CsInputTextComponent,
    CsPagination2Component
  ],
  providers: [...vssProviders]
})
export class VssUiControlsModule { }
